import { LANDING_PAGES, normalizeLandingPath } from "./landing/registry";

export const LANDING_PATHS: readonly string[] = LANDING_PAGES.map((page) => page.path);

export function isLandingPath(pathname: string) {
  return LANDING_PATHS.includes(normalizeLandingPath(pathname));
}
